<svg class="{$$props.class}" viewBox="0 -25 424 424">
  <path
    fill="currentColor"
    d="M167.3 272.1a7 7 0 01-4.5-1.6l-45.3-38.6a7 7 0 010-10.7l45.3-38.5a7 7 0
    119 10.6l-39 33.3 39 33.2a7 7 0 01-4.5 12.3zm89.4 0a7 7 0
    01-4.5-12.3l39-33.2-39-33.3a7 7 0 019-10.6l45.3 38.5a7 7 0 010 10.7l-45.3
    38.6a7 7 0 01-4.5 1.6zm-60.7 29a7 7 0 01-6.9-8.5l28.2-134a7 7 0 0113.7
    2.9l-28.2 134a7 7 0 01-6.8 5.6zm0 0" />
  <path
    fill="currentColor"
    d="M377 374H47c-26 0-47-21-47-47V47C0 21 21 0 47 0h330c26 0 47 21 47
    47v280c0 26-21 47-47 47zM47 14a33 33 0 00-33 33v280a33 33 0 0033 33h330a33
    33 0 0033-33V47a33 33 0 00-33-33zm0 0" />
  <path
    fill="currentColor"
    d="M417 112H7a7 7 0 110-14h410a7 7 0 010 14zM119.6 78.7a22.2 22.2 0
    01-22.1-22.2 22.2 22.2 0 0122.1-22.1 22.2 22.2 0 0122.1 22.1 22.2 22.2 0
    01-22.1 22.2zm0-30.3a8.2 8.2 0 000 16.3 8.2 8.2 0 000-16.3zm-68 30a22.2 22.2
    0 01-22.2-22A22.2 22.2 0 0151.5 34a22.2 22.2 0 0122.2 22.1 22.2 22.2 0
    01-22.2 22.2zm0-30.2a8.2 8.2 0 108 8.1c0-4.5-3.6-8.1-8-8.1zm136 30.7a22.2
    22.2 0 01-22-22.1 22.2 22.2 0 0122-22.2 22.2 22.2 0 0122.2 22.1 22.2 22.2 0
    01-22.1 22.2zm0-30.3a8.2 8.2 0 100 16.3 8.2 8.2 0 000-16.3zm0 0" />
</svg>
